import React, { useEffect } from 'react';
import cl from 'classnames';
import { Swiper } from 'antd-mobile';
// import { history } from 'umi';
import { HexToRGB, shouldShowImage, appUrlJump } from '@/utils/utils';
import { trackSensors } from '@/utils/sensors';
import singleBg from '@/assets/images/ic_bg_assembly.svg';
import Clickable from '@/components/Clickable';
import styles from './index.less';

export default function FloorPoster({
  visible,
  showTitle,
  title,
  showMore,
  moreName,
  moreLink,
  moreLinkType,
  titleIconPosition = 'L',
  titleIcon = [
    {
      src: singleBg,
      width: 0,
      height: 0,
      iconName: '',
      linkType: '',
      link: '',
      linkId: '',
    },
  ],
  moreIcon = [
    {
      src: singleBg,
      width: 0,
      height: 0,
      iconName: '',
      linkType: '',
      link: '',
      linkId: '',
    },
  ],
  floorStyle,
  pictures,
  indicatorVisible,
  titleFontSize,
  titleFontColor,
  titleFontColorOpacity,
  isTitleFontBold,
  isTitleFontItalic,
  isTitleBg,
  titleBgColor,
  titleBgColorOpacity,
  staticTitleFontSize,
  staticTitleFontColor,
  staticTitleFontColorOpacity,
  isStaticTitleFontBold,
  isStaticTitleFontItalic,
  imageTitleFontSize,
  imageTitleFontColor,
  imageTitleFontColorOpacity,
  isImageTitleFontBold,
  isImageTitleFontItalic,
  imageTitlePosition = 'Left',
  contentTitlePosition = 'Left',
  contentFontSize,
  contentFontColor,
  contentFontColorOpacity,
  isContentFontBold,
  isContentFontItalic,
  contentLineHeight = 1.2,
  titleLineHeight = 1.2,
  // iconFontColor,
  // iconFontColorOpacity,
  // iconFontSize,
  // isIconNameFontBold,
  // isIconNameFontItalic,
  bgImg,
  hasBackground,
  bgType,
  bgColor,
  bgColorOpacity,
  topMargin,
  bottomMargin,
  horizontalOutterMargin,
  topPadding,
  bottomPadding,
  horizontalInnerLeftPadding,
  horizontalInnerRightPadding,
  objFocus,
  horizontalInnerSpacing,
  hasFixedBg,
  imageTitleSpacing,
  titleContentSpacing,
  isStaticTitleUnderLine = 'N',
}) {
  const localState = localStorage.getItem('currState');
  const settingState = localStorage.getItem('settingModal');
  const prevState = localStorage.getItem('currPrevState');

  const bgStyle = {
    marginTop: `${topMargin / 100}rem`,
    marginBottom: `${bottomMargin / 100}rem`,
    marginLeft: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    marginRight: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    backgroundColor:
      hasBackground === 'Y' && bgType === 'Color'
        ? HexToRGB(bgColor, bgColorOpacity)
        : 'transparent',
    backgroundImage: hasBackground === 'Y' && bgType === 'Image' ? `url(${bgImg.src})` : 'initial',
    backgroundSize: '100% 100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    height:
      ['R1C1', 'R1C2', 'R1C3', 'R1C4'].includes(floorStyle) &&
      hasFixedBg === 'Y' &&
      bgImg.height !== 0
        ? `${bgImg.height / 2 / 100}rem`
        : 'auto',
  };

  const titleStyles = {
    fontSize: `${titleFontSize / 100}rem`,
    color: HexToRGB(titleFontColor, titleFontColorOpacity),
    fontWeight: isTitleFontBold === 'Y' ? 'bold' : 'normal',

    fontStyle: isTitleFontItalic === 'Y' ? 'italic' : 'normal',
    border: objFocus?.titleFocus === 'Y' ? '2px dashed #e0e0e0' : '2px solid transparent',
  };

  const moreStyles = {
    fontSize: `${staticTitleFontSize / 100}rem`,
    color: HexToRGB(staticTitleFontColor, staticTitleFontColorOpacity),
    fontWeight: isStaticTitleFontBold === 'Y' ? 'bold' : 'normal',
    // fontFamily: isStaticTitleFontBold === 'Y' ? 'NunitoSans-Bold' : 'NunitoSans-Regular',
    fontStyle: isStaticTitleFontItalic === 'Y' ? 'italic' : 'normal',
    border: objFocus?.moreFocus === 'Y' ? '2px dashed #e0e0e0' : '2px solid transparent',
    display: !showMore || !showTitle ? 'none' : '',
    textDecoration: isStaticTitleUnderLine === 'Y' ? 'underline' : 'none',
    marginRight:
      floorStyle === 'INF'
        ? `${
          hasFixedBg === 'Y'
            ? `${(376 * Number(horizontalInnerRightPadding)) / 100 / 100}rem`
            : `${Number(horizontalInnerRightPadding || 0) / 100}rem`
        }`
        : '0',
  };

  const iconStyles = {
    fontSize: `${imageTitleFontSize / 100}rem`,
    color: HexToRGB(imageTitleFontColor, imageTitleFontColorOpacity),
    fontWeight: isImageTitleFontBold === 'Y' ? 'bold' : 'normal',
    // fontFamily: isImageTitleFontBold === 'Y' ? 'Roboto-bold' : 'Roboto',
    fontStyle: isImageTitleFontItalic === 'Y' ? 'italic' : 'normal',
    textAlign: imageTitlePosition,
    lineHeight: titleLineHeight || 1.2,
    // border: objFocus?.moreFocus === 'Y' ? '2px dashed #e0e0e0' : '2px solid transparent',
  };

  const contentStyles = {
    fontSize: `${contentFontSize / 100}rem`,
    color: HexToRGB(contentFontColor, contentFontColorOpacity),
    fontWeight: isContentFontBold === 'Y' ? 'bold' : 'normal',
    // fontFamily: isContentFontBold === 'Y' ? 'Roboto-bold' : 'Roboto',
    fontStyle: isContentFontItalic === 'Y' ? 'italic' : 'normal',
    textAlign: contentTitlePosition,
    lineHeight: contentLineHeight || 1.2,
    // border: objFocus?.moreFocus === 'Y' ? '2px dashed #e0e0e0' : '2px solid transparent',
  };

  const titleBgStyle = {
    background: HexToRGB(titleBgColor, titleBgColorOpacity),
  };

  // const innerStyle = {
  //   paddingTop: hasFixedBg === 'Y' ? topPadding / bg : `${topPadding}px`,
  //   paddingBottom: `${bottomPadding}px`,
  //   paddingLeft: `${Number(horizontalInnerLeftPadding || 0)}px`,
  //   paddingRight: `${Number(horizontalInnerRightPadding || 0)}px`,
  // };

  const getInnerStyle = () => {
    if (hasFixedBg === 'Y') {
      return {
        paddingTop: `${(Number(topPadding) * bgImg?.height) / 100 / 100}rem`,
        paddingBottom: `${(Number(bottomPadding) * bgImg?.height) / 100 / 100}rem`,
        paddingLeft: `${(376 * Number(horizontalInnerLeftPadding)) / 100 / 100}rem`,
        paddingRight:
          floorStyle === 'INF'
            ? '0rem'
            : `${(376 * Number(horizontalInnerRightPadding)) / 100 / 100}rem`,
      };
    }
    return {
      paddingTop: `${topPadding / 100}rem`,
      paddingBottom: `${bottomPadding / 100}rem`,
      paddingLeft: `${Number(horizontalInnerLeftPadding || 0) / 100}rem`,
      paddingRight:
        floorStyle === 'INF' ? '0px' : `${Number(horizontalInnerRightPadding || 0) / 100}rem`,
    };
  };

  const getDivImageStyle = () => {
    const hasSizeList = pictures.filter(item => item.width !== 0);
    // const hasIconNameList = pictures.filter((item) => item.iconName?.length !== 0);
    let imageDivStyle = {};
    if (hasSizeList.length > 0) {
      const imageWidth = hasSizeList[0].width;
      // const imageHeight = hasSizeList[0].height;
      // const realWidth = (imageWidth * 344) / 750;
      const realWidth = imageWidth;
      // const realHeight = (realWidth * imageHeight) / imageWidth;
      // const lastImageDivHeight = realHeight + (hasIconNameList.length > 0 ? 22 : 0);
      imageDivStyle = {
        width: realWidth,
        // height: lastImageDivHeight,
      };
    }
    return imageDivStyle;
  };

  const getImageStyle = () => {
    const hasSizeList = pictures.filter(item => item.width !== 0);
    let imageStyle = {};
    if (hasSizeList.length > 0) {
      const imageWidth = hasSizeList[0].width;
      const imageHeight = hasSizeList[0].height;
      // const realWidth = (imageWidth * 344) / 750;
      const realWidth = imageWidth;
      const realHeight = (realWidth * imageHeight) / imageWidth;
      imageStyle = {
        width: realWidth,
        height: realHeight,
      };
    }
    return imageStyle;
  };

  const getSwiperDivStyle = () => {
    const hasSizeList = pictures.filter(item => item.width !== 0);
    // const hasIconNameList = pictures.filter((item) => item.iconName?.length !== 0);
    let imageDivStyle = {};
    if (hasSizeList.length > 0) {
      const imageWidth = hasSizeList[0].width;
      // const imageHeight = hasSizeList[0].height;
      const realWidth = (imageWidth * 334) / 750;
      // const realHeight = (realWidth * imageHeight) / imageWidth;
      // const lastImageDivHeight = realHeight + (hasIconNameList.length > 0 ? 22 : 0);
      imageDivStyle = {
        width: realWidth,
        // height: lastImageDivHeight,
      };
    }
    return imageDivStyle;
  };

  const getSwiperImageStyle = () => {
    const hasSizeList = pictures.filter(item => item.width !== 0);
    let imageStyle = {};
    if (hasSizeList.length > 0) {
      const imageWidth = hasSizeList[0].width;
      const imageHeight = hasSizeList[0].height;
      const realWidth = (imageWidth * 334) / 750;
      const realHeight = (realWidth * imageHeight) / imageWidth;
      imageStyle = {
        width: realWidth,
        height: realHeight,
      };
    }
    return imageStyle;
  };

  const getSlideSize = () => {
    const hasSizeList = pictures.filter(item => item.width !== 0);
    let slideSize = 100;
    if (hasSizeList.length > 0) {
      const imageWidth = hasSizeList[0].width;
      const realWidth = (imageWidth / 750) * 100;
      slideSize = realWidth;
    }
    return slideSize;
  };

  // const getNameHeight = () => {
  //   const hasIconNameList = pictures.filter((item) => item.iconName?.length !== 0);
  //   let nameStyle = {};
  //   if (hasIconNameList.length > 0) {
  //     nameStyle = {
  //       height: '22px',
  //     };
  //   }
  //   return nameStyle;
  // };

  const getTitleBg = () => {
    const whiteBg = {
      background: 'transparent',
    };
    if (hasBackground === 'Y' && isTitleBg === 'Y') {
      return whiteBg;
    }
    if (hasBackground === 'N' && isTitleBg === 'Y') {
      return titleBgStyle;
    }
    return { paddingLeft: 0 };
  };

  const getImgStyle = (value, key) => {
    let newheight = 'auto';
    let newWidth = 'auto';
    if (value?.height !== 0) {
      if (hasFixedBg === 'Y') {
        newheight = `${value?.height / 2 / 100}rem`;
      } else {
        newheight = 'auto';
      }
    } else if (key === 'R1C1') {
      newheight = '196px';
    } else if (key === 'R1C2') {
      newheight = 'auto';
    } else if (key === 'R1C3') {
      newheight = 'auto';
    } else {
      newheight = '180px';
    }

    if (value?.width !== 0) {
      if (hasFixedBg === 'Y') {
        newWidth = `${value?.width / 2 / 100}rem`;
      } else {
        newWidth = '100%';
      }
    } else {
      newWidth = '100%';
    }
    return {
      width: newWidth,
      height: newheight,
      // marginBottom: '-4px',
    };
  };

  const innerSpacingStyle = {
    marginRight: `${horizontalInnerSpacing / 100}rem`,
  };

  const innerGapStyle = {
    gap: `${horizontalInnerSpacing / 100}rem`,
  };

  const handleAppUrlJump = (url, schemaType = '', pictureObj) => {
    trackSensors('reward_exclusive_listing', {
      category: 'reward_exclusive',
      action: 'button_click',
      label: 'cta',
      section: 'rewards',
      product_name: pictureObj?.iconName || '',
    });

    appUrlJump(url, Number(schemaType) === 1 || Number(schemaType) === 5);
  };

  const getSpacedImageStyle = imageStyle =>
    imageStyle
      ? {
        ...imageStyle,
        marginBottom: `${imageTitleSpacing / 100}rem`,
      }
      : undefined;

  const renderImageText = (item, hidden) => {
    if (hidden || !(item?.imageTitle || item?.contentText)) {
      return null;
    }

    return (
      <div className={styles.textBox}>
        {item?.imageTitle && (
          <div
            className={styles.imageTitle}
            style={{
              ...iconStyles,
              marginBottom: `${titleContentSpacing / 100}rem`,
            }}
          >
            {item.imageTitle}
          </div>
        )}
        <div className={styles.contentText} style={contentStyles}>
          {item.contentText}
        </div>
      </div>
    );
  };

  const renderFloorItem = ({
    item,
    index,
    className = styles.previewFloorImgBox,
    style,
    imageStyle,
    hideText = false,
  }) => (
    <Clickable
      className={cl(className)}
      key={index}
      style={style}
      onClick={() => handleAppUrlJump(item?.link, item?.linkType, item)}
    >
      <img
        src={item.src}
        style={getSpacedImageStyle(imageStyle)}
        alt=""
        onError={e => {
          e.target.onerror = null;
          e.target.src = singleBg;
        }}
      />
      {renderImageText(item, hideText)}
    </Clickable>
  );

  const renderR2C2Row = (rowPictures, keyOffset = 0) => (
    <div className={styles.previewRowBox} style={innerGapStyle}>
      {(rowPictures || []).map((item, index) =>
        renderFloorItem({
          item,
          index: keyOffset + index,
          style: { marginRight: 0 },
          imageStyle: getImgStyle(item, floorStyle),
        }),
      )}
    </div>
  );

  useEffect(() => {
    trackSensors('reward_exclusive_listing', {
      category: 'reward_exclusive',
      action: 'screen_view',
      section: 'rewards',
    });
  }, []);

  // 6种场景
  // 1.一行一图
  // 2.一行两图
  // 3.一行三图
  // 4.左一右二
  // 5.左二右一
  // 6.一行多图
  // 7.一行四图
  const renderFloor = () => {
    if (['R1C1', 'R1C2', 'R1C3', 'R1C4'].includes(floorStyle)) {
      return (
        <div
          className={cl(styles.containRCBox)}
          style={{
            justifyContent:
              hasFixedBg === 'Y' && horizontalInnerLeftPadding === '0' ? 'flex-end' : 'flex-start',
          }}
        >
          {(pictures || []).map((item, index) =>
            renderFloorItem({
              item,
              index,
              style: innerSpacingStyle,
              imageStyle: getImgStyle(item, floorStyle),
              hideText: floorStyle === 'R1C4',
            }),
          )}
        </div>
      );
    }
    if (['R2C2'].includes(floorStyle)) {
      return (
        <div className={cl(styles.containR2C2Box)} style={innerGapStyle}>
          {renderR2C2Row(pictures.slice(0, 2))}
          {renderR2C2Row(pictures.slice(2, 4), 2)}
        </div>
      );
    }
    if (['L1R2', 'L2R1'].includes(floorStyle)) {
      return (
        <div className={cl(styles.gridBox)}>
          {(pictures || []).map((item, index) =>
            renderFloorItem({
              item,
              index,
              className: cl(
                styles.previewFloorImgBox,
                floorStyle === 'L1R2' ? styles.L1R2 : styles.L2R1,
              ),
              hideText: true,
            }),
          )}
        </div>
      );
    }
    if (indicatorVisible === '0') {
      return (
        <div className={cl(styles.infiniteBox)} style={innerGapStyle}>
          {(pictures || []).map((item, index) =>
            renderFloorItem({
              item,
              index,
              style: getDivImageStyle(),
              imageStyle: getImageStyle(),
            }),
          )}
        </div>
      );
    }
    return (
      <div className={cl(styles.infiniteBox)}>
        <Swiper
          trackOffset={6}
          slideSize={getSlideSize()}
          defaultIndex={0}
          style={{
            '--track-padding': ' 0 0 16px',
          }}
        >
          {(pictures || [])
            .filter(item => shouldShowImage(item.src))
            .map((item, index) => (
              <Swiper.Item key={index}>
                {renderFloorItem({
                  item,
                  index,
                  className: styles.previewIndicatorImgBox,
                  style: getSwiperDivStyle(),
                  imageStyle: getSwiperImageStyle(),
                })}
              </Swiper.Item>
            ))}
        </Swiper>
      </div>
    );
  };

  return (
    <div
      className={cl(
        styles.carouselBox,
        localState === '0' || prevState === 'Y' || settingState === 'Y' ? styles.previewBox : null,
        {
          hidden: !visible,
        },
      )}
      style={bgStyle}
    >
      <div className={styles.inner} />
      <div style={getInnerStyle()}>
        <div className={styles.carouselBoxHeader} style={getTitleBg()}>
          {titleIconPosition === 'L' ? (
            <div className={cl(styles.moreTitle, { hidden: !showTitle })} style={titleStyles}>
              {shouldShowImage(titleIcon[0]?.src) && (
                <img style={{ width: '24px', marginRight: '4px' }} alt="" src={titleIcon[0]?.src} />
              )}
              {title}
            </div>
          ) : (
            <div className={cl(styles.moreTitle, { hidden: !showTitle })} style={titleStyles}>
              {title}
              {shouldShowImage(titleIcon[0]?.src) && (
                <img style={{ width: '24px', marginLeft: '4px' }} alt="" src={titleIcon[0]?.src} />
              )}
            </div>
          )}
          <Clickable
            as="a"
            onClick={() => handleAppUrlJump(moreLink, moreLinkType)}
            className={cl(styles.titleMore, {
              hidden: !showMore || !showTitle,
            })}
            style={moreStyles}
          >
            {moreName}
            {shouldShowImage(moreIcon[0]?.src) && (
              <img style={{ width: '24px', marginLeft: '4px' }} alt="" src={moreIcon[0]?.src} />
            )}
          </Clickable>
        </div>
        <div className={styles.floorBox}>{renderFloor()}</div>
      </div>
    </div>
  );
}
